module.exports = __webpack_public_path__ + "files/f955777e38bc8d9b60afff9ac53f9f23.png";